import type { LogEntry } from "@/types/api";

// In HA deployments each replica serves logs from its own in-process ring
// buffer, so successive polls can come from different nodes whose sibling
// entries are interleaved differently. Ordering by timestamp keeps the
// rendered list stable across polls (same family as TTTL-83); entries with
// unparseable timestamps keep their relative server order.
export function sortLogsNewestFirst(logs: LogEntry[]): LogEntry[] {
  const ts = (entry: LogEntry) => {
    const parsed = Date.parse(entry.timestamp);
    return Number.isNaN(parsed) ? 0 : parsed;
  };
  return logs.slice().sort((a, b) => ts(b) - ts(a));
}
